import { useAbility } from "@/casl-provider";
import { checkPermission } from "@/common/helpers/navigation";
import type { DetailPermission } from "@/components/detail-page/types";
import { userStore } from "@/store/user-store";
import { useMemo } from "react";

interface PermissionGated {
  permission?: DetailPermission;
}

export function usePermittedItems<T extends PermissionGated>(items: T[]): T[] {
  const ability = useAbility();
  const userRoles = userStore((state) => state.user?.roles);

  return useMemo(
    () => items.filter((item) => !item.permission || checkPermission(ability, item.permission, userRoles)),
    [items, ability, userRoles],
  );
}
